<mat-accordion>
	<mat-expansion-panel *ngIf="titleText" test-id="mobile-footer-menu-header">
		<mat-expansion-panel-header [expandedHeight]="'48px'" [collapsedHeight]="'48px'">
			<mat-panel-title>
				{{ titleText }}
			</mat-panel-title>
		</mat-expansion-panel-header>
		<a
			*ngFor="let item of items; trackBy: trackByItem"
			[attr.test-id]="'mobile-footer-menu-child-' + item.title"
			[obgRouteLink]="{ route: item.route, url: item.link?.url, target: item.link?.target }"
			[target]="item.link?.target"
			[obgInteraction]="uiInteraction"
			>{{ item.title }}
		</a>
	</mat-expansion-panel>
</mat-accordion>
